// extracted by mini-css-extract-plugin
export default {"InfoItemTitle":"styles_InfoItemTitle__RB6i9","InfoItemTitleText":"styles_InfoItemTitleText__rNuZa","InfoItemTitleIcon":"styles_InfoItemTitleIcon__VeR6N"};